
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M8.158 6.93c.284-3.301 1.98-4.648 5.693-4.648h.119c4.1 0 5.738 1.641 5.738 5.738v5.977c0 4.1-1.641 5.738-5.738 5.738h-.119c-3.685 0-5.381-1.329-5.683-4.574"}}),_c('g',{attrs:{"opacity":".4"}},[_c('path',{attrs:{"d":"M1.833 11H13.64M11.596 7.93l3.071 3.071-3.071 3.071"}})])])])
          )
        }
      }
    